import { render, staticRenderFns } from "./ClaimPaymentDetails.vue?vue&type=template&id=62f9150a&"
import script from "./ClaimPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./ClaimPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports